<template>
  <styleLoader />
  <router-view />
</template>

<script>
import { computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
// import qs from 'qs'
// import Localization from '@/localization'
import StyleLoader from '@/styleLoader'

export default {
  name: 'App',
  components: { StyleLoader },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const logo = computed(() => store.getters.settings.logo)
    const currentRoute = computed(() => route)
    const authorized = computed(() => store.getters['user/user'].authorized)

    // watch page title change
    watch(
      currentRoute,
      (routeData) => {
        const title = routeData.meta.title
        const isMobileCms = routeData.path.includes('mobile-cms')
        const prefix = isMobileCms ? 'Mobile' : 'Inaheart'
        document.title = title ? `${prefix} | ${title}` : prefix
      },
      { deep: true, immediate: true },
    )

    // initial auth check
    onMounted(async () => {
      // Load user data from localStorage to store
      const perkiUser = localStorage.getItem('perki_user')
      const perkiRole = localStorage.getItem('perki_role')
      const perkiToken = localStorage.getItem('perki_token')
      await store.dispatch('user/LOAD_CURRENT_ACCOUNT', { token: perkiToken })
      if (perkiUser && perkiToken) {
        try {
          const user = JSON.parse(perkiUser)
          store.commit('user/SET_STATE', {
            id: user.id,
            name: user.name,
            email: user.email,
            role: perkiRole || user.role,
            authorized: true,
          })
        } catch (err) {
          console.error('Failed to parse user data:', err)
        }
      }
    })

    // redirect if authorized and current page is login
    watch(authorized, authorized => {
      // if (authorized) {
      //   const query = qs.parse(currentRoute.value.fullPath.split('?')[1], {
      //     ignoreQueryPrefix: true,
      //   })
      //   router.push(query.redirect || '/')
      // }
    })
  },
}
</script>
